export const BENEFIT_GROUPS = {
    BASE_SALARY: 'BaseSalary',
    EXTRA_SALARY: 'ExtraSalary',
    COMMISSION: 'Commission',
    MEANS_OF_WORK: 'MeansOfWork',
}